import React from "react";
import { useLocation } from "react-router-dom";
import DefaultLayout from "app/layouts/DefaultLayout";
import Reservation from "app/components/Reservation";

function ReservationCreatePage(props) {
  const { state } = useLocation();
  const { salonItem } = state;

  return (
    <DefaultLayout
      headerProps={{
        headerClassName: "md:!block",
        pageTitle: "予約する",
      }}>
      <Reservation.Form>{salonItem}</Reservation.Form>
    </DefaultLayout>
  );
}

export default ReservationCreatePage;
